/**
 * Ввод СНИЛС (centrika-docs!46, `common.md` → «Поля СНИЛС»). Правила общие для ВСЕХ полей
 * ввода и изменения СНИЛС: из значения удаляются все символы кроме цифр, ввод ограничен
 * 11 цифрами, маска `000-000-000 00` формируется автоматически по мере ввода.
 *
 * Проверка корректности (11 цифр + контрольная сумма) живёт в `lib/validation`
 * (`isValidSnils`) — она была раньше этого требования и уже используется анкетой СОУТ;
 * разделители маски она не учитывает, поэтому формат значения на неё не влияет.
 */

/** Длина СНИЛС в цифрах. */
export const SNILS_LENGTH = 11

/** Placeholder полей СНИЛС — он же образец маски (используется в формах). */
export const SNILS_PLACEHOLDER = '000-000-000 00'

/** Сообщение о некорректном СНИЛС (11 цифр + контрольная сумма). */
export const SNILS_MESSAGE = 'Проверьте СНИЛС: 11 цифр и контрольная сумма'

/** Оставляет только цифры и обрезает до 11 — и при наборе, и при вставке. */
export function keepSnilsDigits(value: string): string {
  return value.replace(/\D/g, '').slice(0, SNILS_LENGTH)
}

/**
 * Формирует маску `000-000-000 00` по имеющимся цифрам: разделители появляются по мере
 * ввода и не «забегают» вперёд (после трёх цифр — дефис, перед двумя последними — пробел).
 */
export function formatSnils(value: string): string {
  const d = keepSnilsDigits(value)
  const parts = [d.slice(0, 3), d.slice(3, 6), d.slice(6, 9)].filter((p) => p !== '')
  const head = parts.join('-')
  const tail = d.slice(9)
  return tail === '' ? head : `${head} ${tail}`
}

/**
 * Позиция каретки после форматирования: считаем, сколько ЦИФР стояло до каретки в сыром
 * вводе, и ставим каретку после стольких же цифр в отформатированном значении — иначе
 * правка середины значения «прыгала» бы в конец.
 */
export function snilsCaretPosition(formatted: string, digitsBeforeCaret: number): number {
  if (digitsBeforeCaret <= 0) return 0
  let seen = 0
  for (let i = 0; i < formatted.length; i++) {
    if (/\d/.test(formatted[i])) {
      seen += 1
      if (seen === digitsBeforeCaret) return i + 1
    }
  }
  return formatted.length
}

/** Сколько цифр стоит в строке до позиции caret (для сохранения места каретки). */
export function countDigitsBefore(value: string, caret: number): number {
  return value.slice(0, Math.max(0, caret)).replace(/\D/g, '').length
}
